export default (() => {
    $('a[href^="#"]').each(function() {
        const a$ = $(this);
        const href = a$.attr('href');

        if(href === '#open-terms' || href.indexOf('open-widget') !== -1 || href.indexOf('download-brochure') !== -1 || href.indexOf('cart-modal') !== -1) {
            return;
        }

        a$.click(e => {
            const nav$ = $('.main-menu') ? $('.main-menu') : 0;
            const top$ = $('.top-bar') ? $('.top-bar') : 0;
            const adminBar$ = $('#wpadminbar') ? $('#wpadminbar') : 0;

            let target$ = $(href);

            if(!target$.length) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            window.scroll({
                top: target$.offset().top - (nav$.outerHeight() + top$.outerHeight() + adminBar$.outerHeight()),
                behavior: 'smooth',
            });
        });
    });

    if(window.location.hash) {
        scroll(0,0);
        setTimeout( function() {
            const nav$ = $('.main-menu') ? $('.main-menu') : 0;
            const top$ = $('.top-bar') ? $('.top-bar') : 0;
            const adminBar$ = $('#wpadminbar') ? $('#wpadminbar') : 0;

            $('html, body').animate({
                scrollTop: ($(window.location.hash).offset().top - (nav$.outerHeight() + top$.outerHeight() + adminBar$.outerHeight())) + 'px',
            }, 1000, 'swing');
        }, 1500);
    }
});



// WEBPACK FOOTER //
// ./scripts/util/smooth-scroll.js